angular
	.module('selectLanguage.components', [])
	.component('selectLanguage', {
		templateUrl: 'ng/components/selectLanguage/selectLanguage.html',
		bindings: {
			/** An array containing all supported languages **/
			languages: '='
		},
		controllerAs: 'selectLanguageCtrl',
		controller: function SelectLanguageCtrl($translate, $scope, $rootScope, $sce) {
			$scope.htmlPopover = $sce.trustAsHtml('<b style="color: red">I can</b> have <div class="label label-success">HTML</div> content');

			var self = this;

			this.languages = [];
			this.selectedItem = 'it'; //default selected ng-model

			/** Manipulate menu **/
			this.showMenu = false;
			this.toggleMenu = function () {
				this.showMenu ? this.showMenu = false : this.showMenu = true;
			}

			this.$onInit = function () {

				//Array di linguaggi non utilizzati
				this.notUsedLanguages = this.languages && this.languages.filter(function (lang) {
					return lang != self.selectedItem
				})

			}

			/** setta il linguaggio selezionato, e ricalcola l'array di quelli che non lo sono **/
			this.selectLanguage = function (lang) {
				this.selectedItem = this.notUsedLanguages[lang];
				$rootScope.selectedLanguage = this.selectedItem;//** TODO: iniettare un servizio qui e dentro overlayModal per vedere il linguaggio corrente, questo fa schifo!!!!
				this.notUsedLanguages = this.languages.filter(function (lang) {
					return lang != self.selectedItem
				})
				this.setLanguage(this.selectedItem);
				setTimeout(function () {
					var selects = document.querySelectorAll('.form-control.select2');
					selects.forEach(function (select) {
						console.log(select.dataset.placeholder);
						var placeholder = select.dataset.placeholder;
						$(select).data('placeholder', placeholder).select2();

					})
				}, 50);
				//setTimeout(function(){
				//	$('.form-control.select2').each(function(index, select){
				//		var placeholder = $(select).data('placeholder');
				//		$(select).data('placeholder', placeholder).select2();
				//	});
				//},200);
			}

			this.test = function (value) {
				console.log(value);
			}

			this.injectHtml = function () {
				$('.flag').popover();
			}

			this.setLanguage = function (lang) {
				console.log("$translate.use(" + lang + ")");
				$translate.use(lang);
			}



		}
	});